import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Microgreens from "./pages/Microgreens";
import Plans from "./pages/Plans";
import Franchise from "./pages/Franchise";
import FAQ from "./pages/FAQ";
import Founders from "./pages/Founders";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/microgreens" element={<Microgreens />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/franchise" element={<Franchise />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/founders" element={<Founders />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Legal slug="terms" />} />
            <Route path="/privacy" element={<Legal slug="privacy" />} />
            <Route path="/refunds" element={<Legal slug="refunds" />} />
            <Route path="/delivery" element={<Legal slug="delivery" />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0A110D",
            color: "#F7F6F2",
            border: "1px solid rgba(255,255,255,0.1)",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
